// extracted by mini-css-extract-plugin
export default {"container":"qoHiY8xoijJsmE9rQ2PV"};